import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/consolecomponents/sidebar/Sidebar";
import PackageCard from "../../components/PackageCard";
import "./style.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Modal,
} from "@material-ui/core";
import download from "../../Assets/download2.svg";
import downloadIcon from "../../Assets/downloadIcon.png";
import { Close, ExpandMore } from "@material-ui/icons";
import { useGetOneSdkRepo, useGetSdkRepo } from "../../hooks/DevSdkRepoHook";
import { hideLoader, showLoader } from "../../util/loader/CustomLoader";
import DevSdkRepoAPI from "../../api/DevSdkRepo";
import { CustomToast } from "../../util/custom-toast/CustomToast";
import DOMPurify from "dompurify";

const mockVersionData = [
  {
    id: 0,
    version: "4.37.1",
  },
  {
    id: 1,
    version: "4.37.0",
  },
  {
    id: 2,
    version: "4.36.85",
  },
  {
    id: 3,
    version: "Archive",
  },
];

const mockRepoData = {
  _id: "658177268e1a877408cf7419",
  version: "v2.1.1",
  releaseDate: "2023-11-28T15:08:28.901Z",
  isDeprecated: true,
  isPublished: false,
  packages: [
    {
      _id: "658179958e39de7fa82f1f0b",
      title: "JMRSDK Core",
      description:
        "A comprehensive all-in-one package for Unity's built-in render pipeline.",
      type: "core_packages",
      header: "Core Packages",
      id: "231faec9-06c2-49ab-90fd-a400bad11f4f",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f0c",
      title: "JMRSDK for URP",
      description:
        "A Prebuilt Scriptable Render Pipeline offers artist-friendly workflows for creating optimized graphics across all JMRDK platforms",
      type: "core_packages",
      header: "Core Packages",
      id: "a190ba97-68f9-476b-b746-8745df59f21b",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f0d",
      title: "UI Toolkit",
      description:
        "The UI Toolkit package for JioGlass and JioDive enables developers to create feature-rich user interfaces.",
      type: "add_on_packages",
      header: "Add-On Packages",
      id: "6229c455-9f79-4334-ae7c-245c99ad4242",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f0e",
      title: "Custom Scrolls",
      description: "Customized scrolls for JMRSDK",
      type: "add_on_packages",
      header: "Add-On Packages",
      id: "018ba83c-0d97-4ff7-823e-787dcb27bbd0",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f0f",
      title: "Media Player",
      description: "Easy to use media player for JMRSDK",
      type: "add_on_packages",
      header: "Add-On Packages",
      id: "c969d673-99d2-4fba-8fd4-c619888a5edc",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f10",
      title: "Demo XR",
      description:
        "A companion app for testing your apps before they are published on JioImmerse. This version is compatible with JMR SDK v4.37.1 ",
      type: "testing_app",
      header: "Testing App",
      id: "9d04b14c-31c8-409c-b675-268f257cc062",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f11",
      title: "Release Notes",
      description: "Release Notes",
      type: "release_notes",
      header: "Release Notes",
      id: "4a721aac-bca9-47e3-bfbd-c8236455bff7",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
    {
      _id: "658179958e39de7fa82f1f12",
      title: "SDK Bundle",
      description: "SDK Bundle",
      type: "sdk_bundle",
      header: "SDK Bundle",
      id: "935050e6-6a2c-4c66-b465-64fedf5d3fc6",
      iconUrl: "https://www.svgrepo.com/show/325729/unity.svg",
    },
  ],
  id: "cf364e00-f5bc-4fd7-8eaa-1215899012e4",
  created_at: "2023-12-19T10:57:42.746Z",
  updated_at: "2023-12-19T11:08:05.107Z",
  __v: 0,
};

const Downloads = () => {
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showReleaseModal, setShowReleaseModal] = useState(false);
  const [isDownloadsLicenseChecked, setIsDownloadsLicenseChecked] =
    useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [expanded, setExpanded] = useState(null);
  const [packageList, setPackageList] = useState({});
  const [downloadPackage, setDownloadPackage] = useState({});
  const { data: versionList } = useGetSdkRepo();
  const { mutate: getOneSdkRepo, data: oneSdkVersion } = useGetOneSdkRepo();
  const [downloadPackageLink, setDownloadPackageLink] = useState();

  useEffect(() => {
    let id = versionList?.data?.[activeTab]?.id;
    if (id) {
      getOneSdkRepo(id);
    } else {
      setPackageList({});
    }
    setExpanded(null);
  }, [versionList?.data]);

  useEffect(() => {
    const splitPackage = {};
    oneSdkVersion?.packages?.forEach((item) => {
      if (Object.keys(splitPackage).includes(item.header)) {
        splitPackage[item.header].push(item);
      } else {
        splitPackage[item.header] = [item];
      }
    });
    setPackageList(splitPackage);
  }, [oneSdkVersion]);

  const downloadModalStyle = {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "calc(50% + 13rem)",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: 700,
    backgroundColor: "#1D1D1D",
    boxShadow: 24,
    borderRadius: 10,
    p: 4,
    gap: 30,
    color: "#fff",
    textAlign: "center",
    padding: "40px 30px",
    outLine: "none",
    "&:focus-visible": {
      outline: "none",
    },
  };

  const releaseModalStyle = {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "calc(50% + 13rem)",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: 700,
    backgroundColor: "#1D1D1D",
    boxShadow: 24,
    borderRadius: 10,
    p: 4,
    gap: 16,
    color: "#fff",
    padding: "24px",
    outLine: "none",
    "&:focus-visible": {
      outline: "none",
    },
  };

  const handleDownloads = (item) => {
    setShowDownloadModal(true);
    setDownloadPackage(item);
  };

  const handleDownloadModal = () => {
    const { path, packageUrl } = downloadPackageLink;
    downloadPackageWithUrl(packageUrl, path);
    setShowDownloadModal(false);
    setIsDownloadsLicenseChecked(false);
  };

  const closeDownloadModal = () => {
    setIsDownloadsLicenseChecked(false);
    setShowDownloadModal(false);
  };

  const downloadPackageWithUrl = (url, name) => {
    var link = document.createElement("a");
    link.setAttribute("download", name);
    link.href = url;
    link.target = '_blank'
    document.body.appendChild(link);
    link.click();
    link.remove();
    // setDownloadPackageLink({});
  };

  const getDate = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  const handleCheckBox = () => {
    if (!isDownloadsLicenseChecked) {
      getDownloadPackageUrl(oneSdkVersion?.id, downloadPackage.id);
    }
    setIsDownloadsLicenseChecked(!isDownloadsLicenseChecked);
  };

  const handleDoc = async (repoId, packageId) => {
    try {
      let api = new DevSdkRepoAPI();
      showLoader();
      const res = await api.getPackageDownloadUrl(repoId, packageId);
      hideLoader();
      const { path } = res?.data?.data?.packages?.[0];
      try {
        const url = new URL(path, window.location.origin);
        if (!["http:", "https:"].includes(url.protocol)) {
          throw new Error("Invalid URL protocol");
        }
        window.open(url.href);
      } catch {
        CustomToast("Invalid download URL");
      }
    } catch (error) {
      hideLoader();
      CustomToast(error.response.data.message);
    }
  };

  const getDownloadPackageUrl = async (repoId, packageId) => {
    try {
      let api = new DevSdkRepoAPI();
      showLoader();
      const res = await api.getPackageDownloadUrl(repoId, packageId);
      const responseData = res?.data?.data?.packages?.[0];
      setDownloadPackageLink(responseData);
      hideLoader();
    } catch (error) {
      hideLoader();
      CustomToast(error.response.data.message);
    }
  };

  return (
    <div className="downloads">
      <Navbar />
      <div className="downloads_body" style={{ display: "flex" }}>
        <Sidebar />
        <div className="downloads_main">
          <div className="downloads_heading">
            <h2>Downloads</h2>
          </div>
          <div className="downloads_content">
            <div className="tabs">
              {versionList?.data.map(
                (item, index) =>
                  index < 3 && (
                    <span
                      onClick={() => {
                        setExpanded(null);
                        getOneSdkRepo(item?.id);
                        setActiveTab(index);
                      }}
                      key={item?.id}
                      className={`tab_title ${
                        index === activeTab ? "tab_active" : "tab_border"
                      }`}
                    >
                      {item?.version}
                    </span>
                  )
              )}
              <span
                onClick={() => {
                  setActiveTab(3);
                }}
                className={`tab_title ${
                  2 < activeTab ? "tab_active" : "tab_border"
                }`}
              >
                Archive
              </span>
            </div>
            <hr className="hr-line" />

            {activeTab <= 2 ? (
              Object.keys(packageList)?.length && (
                <div className="downloads_tab_wrapper">
                  {packageList?.["Core Packages"]?.length && (
                    <div className="packages_wrapper">
                      <div className="packages_header">
                        <span className="packages_title">Core Packages</span>
                        <div
                          className="archive_btn"
                          onClick={() => {
                            setShowDownloadModal(true);
                            setDownloadPackage(
                              JSON.parse(
                                JSON.stringify(packageList?.["SDK Bundle"]?.[0])
                              )
                            );
                          }}
                        >
                          <div className="archive_btn_icon">
                            <img src={download} alt="download" />
                          </div>
                          <button>Downloads</button>
                        </div>
                        {packageList?.["Release Notes"]?.[1]?.id && (
                          <Button
                            className="release_notes_btn"
                            variant="outlined"
                            onClick={() =>
                              handleDoc(
                                oneSdkVersion?.id,
                                packageList?.["Release Notes"]?.[1]?.id
                              )
                            }
                          >
                            Documentation
                          </Button>
                        )}
                        <Button
                          className="release_notes_btn"
                          variant="outlined"
                          onClick={() => {
                            setShowReleaseModal(true);
                            getDownloadPackageUrl(
                              oneSdkVersion?.id,
                              packageList?.["Release Notes"]?.[0]?.id
                            );
                            setDownloadPackage(
                              JSON.parse(
                                JSON.stringify(
                                  packageList?.["Release Notes"]?.[0]
                                )
                              )
                            );
                          }}
                        >
                          Release Notes
                        </Button>
                      </div>
                      <div className="packages">
                        {packageList?.["Core Packages"]?.map((item) => (
                          <PackageCard
                            key={item?.id}
                            title={item?.title}
                            description={item?.description}
                            version={oneSdkVersion?.version}
                            date={oneSdkVersion?.releaseDate}
                            iconSrc={item?.iconUrl}
                            handleClick={() => handleDownloads(item)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  {packageList?.["Add-On Packages"]?.length && (
                    <div className="packages_wrapper">
                      <div className="packages_header">
                        <span className="packages_title">Add-On Packages</span>
                      </div>
                      <div className="packages">
                        {packageList?.["Add-On Packages"]?.map((item) => (
                          <PackageCard
                            key={item?.id}
                            title={item?.title}
                            description={item?.description}
                            version={oneSdkVersion?.version}
                            date={oneSdkVersion?.releaseDate}
                            iconSrc={item?.iconUrl}
                            handleClick={() => handleDownloads(item)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  {packageList?.["Testing App"]?.length && (
                    <div className="packages_wrapper">
                      <div className="packages_header">
                        <span className="packages_title">Testing App</span>
                        <Button variant="outlined">Release Notes</Button>
                      </div>
                      <div className="packages">
                        {packageList?.["Testing App"]?.map((item) => (
                          <PackageCard
                            key={item?.id}
                            title={item?.title}
                            description={item?.description}
                            version={oneSdkVersion?.version}
                            date={oneSdkVersion?.releaseDate}
                            iconSrc={item?.iconUrl}
                            handleClick={() => handleDownloads(item)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )
            ) : (
              <div className="accordion-scroll">
                {versionList?.data?.map(
                  (item, index) =>
                    index > 2 && (
                      <Accordion
                        id="accordion"
                        expanded={expanded === index}
                        onChange={() => {
                          setExpanded(expanded === index ? null : index);
                          if (expanded !== index) {
                            getOneSdkRepo(item?.id);
                          }
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore style={{ color: "#fff" }} />}
                          aria-controls="panel1a-content"
                          id="accordion-header-wrapper"
                          className="accordion-header-wrapper"
                        >
                          <div className="accordion-header">
                            <div className="accordion-header-title">
                              <span className="accordion-title">JMRSDK</span>
                              {item?.isDeprecated && (
                                <span className="deprecated-text">
                                  (Deprecated)
                                </span>
                              )}
                            </div>
                            <div className="archive_info">
                              <span>Version : {item?.version}</span>
                              <span>|</span>
                              <span>{getDate(item?.releaseDate)}</span>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails id="accordion-details">
                          <div className="downloads_tab_wrapper">
                            {packageList?.["Core Packages"]?.length && (
                              <div className="packages_wrapper">
                                <div className="packages_header">
                                  <span className="packages_title">
                                    Core Packages
                                  </span>
                                  <div
                                    className="archive_btn"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      setShowDownloadModal(true);
                                      // getOneSdkRepo(item?.id)
                                      setDownloadPackage(
                                        JSON.parse(
                                          JSON.stringify(
                                            packageList?.["SDK Bundle"]?.[0]
                                          )
                                        )
                                      );
                                    }}
                                  >
                                    <div className="archive_btn_icon">
                                      <img src={download} alt="download" />
                                    </div>
                                    <button>Downloads</button>
                                  </div>
                                  {packageList?.["Release Notes"]?.[1]?.id && (
                                    <Button
                                      className="release_notes_btn"
                                      variant="outlined"
                                      onClick={() =>
                                        handleDoc(
                                          oneSdkVersion?.id,
                                          packageList?.["Release Notes"]?.[1]
                                            ?.id
                                        )
                                      }
                                    >
                                      Documentation
                                    </Button>
                                  )}
                                  <Button
                                    className="release_notes_btn"
                                    variant="outlined"
                                    onClick={() => {
                                      setShowReleaseModal(true);
                                      getDownloadPackageUrl(
                                        oneSdkVersion?.id,
                                        packageList?.["Release Notes"]?.[0]?.id
                                      );
                                      setDownloadPackage(
                                        JSON.parse(
                                          JSON.stringify(
                                            packageList?.["Release Notes"]?.[0]
                                          )
                                        )
                                      );
                                    }}
                                  >
                                    Release Notes
                                  </Button>
                                </div>
                                <div className="packages">
                                  {packageList?.["Core Packages"]?.map(
                                    (item) => (
                                      <PackageCard
                                        key={item?.id}
                                        title={item?.title}
                                        description={item?.description}
                                        version={oneSdkVersion?.version}
                                        date={oneSdkVersion?.releaseDate}
                                        iconSrc={item?.iconUrl}
                                        handleClick={() =>
                                          handleDownloads(item)
                                        }
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                            {packageList?.["Add-On Packages"]?.length && (
                              <div className="packages_wrapper">
                                <div className="packages_header">
                                  <span className="packages_title">
                                    Add-On Packages
                                  </span>
                                </div>
                                <div className="packages">
                                  {packageList?.["Add-On Packages"]?.map(
                                    (item) => (
                                      <PackageCard
                                        key={item?.id}
                                        title={item?.title}
                                        description={item?.description}
                                        version={oneSdkVersion?.version}
                                        date={oneSdkVersion?.releaseDate}
                                        iconSrc={item?.iconUrl}
                                        handleClick={() =>
                                          handleDownloads(item)
                                        }
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                            {packageList?.["Testing App"]?.length && (
                              <div className="packages_wrapper">
                                <div className="packages_header">
                                  <span className="packages_title">
                                    Testing App
                                  </span>
                                </div>
                                <div className="packages">
                                  {packageList?.["Testing App"]?.map((item) => (
                                    <PackageCard
                                      key={item?.id}
                                      title={item?.title}
                                      description={item?.description}
                                      version={oneSdkVersion?.version}
                                      date={oneSdkVersion?.releaseDate}
                                      iconSrc={item?.iconUrl}
                                      handleClick={() => handleDownloads(item)}
                                    />
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    )
                )}
              </div>
            )}
          </div>
          <Modal
            open={showDownloadModal}
            onClose={closeDownloadModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={downloadModalStyle}>
              <span className="downloads_modal_title">
                {downloadPackage?.title}
              </span>
              <div className="downloads_modal_disc" onClick={handleCheckBox}>
                <Checkbox
                  style={{ color: "#fff" }}
                  color="default"
                  checked={isDownloadsLicenseChecked}
                  // onChange={handleCheckBox}
                />
                <span>
                  I have read and agree to the terms of the{" "}
                  <button
                    onClick={() => {}}
                    className="download_modal_license_btn"
                  >
                    License
                  </button>
                </span>
              </div>
              <div className="_flex _center">
                <span
                  className={`download_modal_btn  ${
                    !isDownloadsLicenseChecked ? "_opacity-0-5" : ""
                  } `}
                >
                  <div className="download_modal_btn_icon">
                    <img src={download} alt="download" />
                  </div>
                  <button
                    disabled={!isDownloadsLicenseChecked}
                    onClick={handleDownloadModal}
                  >
                    Downloads
                  </button>
                </span>
              </div>
            </Box>
          </Modal>
          <Modal
            open={showReleaseModal}
            onClose={() => setShowReleaseModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={releaseModalStyle}>
              <div className="update_wrapper">
                <div className="release_modal_header">
                  <span className="release_modal_title">Release Update</span>
                  <div
                    className="release_modal_download_icon"
                    onClick={handleDownloadModal}
                  >
                    <img src={downloadIcon} alt="downloadIcon" />
                  </div>
                  <Close
                    onClick={() => setShowReleaseModal(false)}
                    className="release_modal_close"
                  />
                </div>
                {/* <ul>
                  <li>Enhance Tracking Experience</li>
                  <li>Resolved VC drift issues in TouchPad.</li>
                  <li>Resolved Gamepad dis-connection issues</li>
                  <li>Enhance Repositioning Experience</li>
                </ul> */}
              </div>
              <div
                className="release-description"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(downloadPackage?.description || ""),
                }}
                style={{ width: "100%", height: "100%" }}
              >
                {/* <iframe
                    src={downloadDataUrl?.packages?.[0]?.packageUrl}
                    title="HTML File"
                    width="100%"
                    height="100%"
                  /> */}
              </div>
              {/* <div className="improvements_wrapper">
                <div className="release_modal_header">
                  <span className="release_modal_title">Improvements</span>
                </div>
                <ul>
                  <li>New Promotional Banner Experience</li>
                  <li>WhatsApp Integrating for promotional Activity</li>
                  <li>Updated Terms &Condition and Privacy Policy</li>
                  <li>Enhance Immersive Shopping Experince</li>
                  <li>Enhance Gaming Experience with Multiplayer Support</li>
                </ul>
              </div>
              <ul>
                <li>
                  Join the Conversation in our{" "}
                  <a href="#" className="community">
                    Community
                  </a>
                </li>
                <li>
                  Check the complete{" "}
                  <a href="#" className="documentation">
                    Documentation
                  </a>
                </li>
              </ul> */}
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Downloads;
